module.exports = __webpack_public_path__ + "static/media/ProximaNova-Semibold.7264b615.ttf";